import React from 'react';
import Sidebar from '../../Components/Sidebar/Sidebar';

const LayoutRoute = ({ component: Component }) => (
  <Layout>
    {Component && <Component />}
  </Layout>
);

const Layout = ({ children }) => (
  <>
    <Sidebar />
    {children}
  </>
);

export default LayoutRoute;
